import { useMediaQuery } from 'usehooks-ts'
import { useSearch } from '@/src/contexts'

import { Button, Divider, theme } from 'antd'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { QueryStringParams } from '@/src/interfaces'

export const SortButton = ({
  searchParams,
  setSearchParams,
}: {
  searchParams: QueryStringParams
  setSearchParams: (params: any) => void
}) => {
  const {
    token: { colorPrimary },
  } = theme.useToken()
  const isMobile = useMediaQuery('(max-width: 768px)')
  const { query } = useSearch()

  const locationParameters = query.locationParameters
  const isSortByDistanceEnabled =
    locationParameters &&
    ((locationParameters.city && locationParameters.state) ||
      locationParameters.zip)

  const isSortByDistance = searchParams.sortBy === 'distance'
  const isSortByLastName = searchParams.sortBy === 'last_name'
  const isAscendingSort = searchParams.sortOrder === 'asc'

  const handleToggleSortOrder = (sortBy: string) => {
    setSearchParams((prev: QueryStringParams) => {
      const isSameCriterion = prev.sortBy === sortBy

      const newSortOrder = isSameCriterion
        ? prev.sortOrder === 'asc'
          ? 'desc'
          : 'asc'
        : 'asc'

      return {
        ...prev,
        sortOrder: newSortOrder,
        sortBy: sortBy || 'last_name',
        offset: 0,
        limit: prev.limit || 10,
      }
    })
  }

  return (
    <div className='flex items-center gap-2'>
      {isSortByDistanceEnabled && (
        <>
          <Button
            onClick={() => handleToggleSortOrder('distance')}
            style={{
              height: isMobile ? 36 : 50,
              fontSize: isMobile ? 13 : 16,
              backgroundColor: 'transparent',
              color: isSortByDistance ? colorPrimary : '',
              border: 'none',
              boxShadow: 'none',
            }}
          >
            <div className='flex items-center'>
              Distance
              {isSortByDistance && (
                <FontAwesomeIcon
                  icon={isAscendingSort ? 'arrow-up' : 'arrow-down'}
                  className='ml-2'
                />
              )}
            </div>
          </Button>
          <Divider type='vertical' style={{ borderColor: 'lightGray' }} />
        </>
      )}
      <Button
        onClick={() => handleToggleSortOrder('last_name')}
        style={{
          height: isMobile ? 36 : 50,
          fontSize: isMobile ? 13 : 16,
          backgroundColor: 'transparent',
          color: isSortByLastName ? colorPrimary : 'inherit',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        <div className='flex items-center'>
          {isSortByLastName && !isAscendingSort ? 'Z-A' : 'A-Z'}
        </div>
      </Button>
    </div>
  )
}
